/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { UserId } from "./UserId";
import { AccountId } from "./AccountId";
export const AccessToken = core.serialization.object({
    accessToken: core.serialization.string(),
    expiresIn: core.serialization.string(),
    expires: core.serialization.string(),
    email: core.serialization.string().optional(),
    userId: UserId.optional(),
    accountId: AccountId.optional(),
});
